import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { OneVedAiUiModule } from 'onevedai-ui-angular';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { GenericTableComponent } from './components/generic-table/generic-table.component';
import { DateSelectComponent } from './components/date-select/date-select.component';
import { FormInputComponent } from './components/form-input/form-input.component';
import { FormSelectComponent } from './components/form-select/form-select.component';
import { MappingDialog } from './components/mapping-dialog/mapping-dialog';
import { PatientSearchDialogComponent } from './components/patient-search-dialog/patient-search-dialog.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { UserProfileMenuComponent } from './components/user-profile-menu/user-profile-menu.component';
import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { AppCheckboxComponent, AppToggleComponent } from './ui/checkable.components';
import { AppSelectComponent, AppOptionComponent } from './ui/select.components';
import { AppTabComponent, AppTabGroupComponent } from './ui/tabs.components';

import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
@NgModule({
  declarations: [
    ConfirmDialogComponent,
    NavbarComponent,
    SidebarComponent,
    GenericTableComponent,
    DateSelectComponent,
    FormInputComponent,
    FormSelectComponent,
    MappingDialog,
    PatientSearchDialogComponent,
    BreadcrumbComponent,
    UserProfileMenuComponent,
    ComingSoonComponent,
    PageHeaderComponent,
    AppCheckboxComponent,
    AppToggleComponent,
    AppSelectComponent,
    AppOptionComponent,
    AppTabComponent,
    AppTabGroupComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    
    OneVedAiUiModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  // Library web components (onevedai-*) are native custom elements
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    ConfirmDialogComponent,
    
    OneVedAiUiModule,
    NavbarComponent,
    SidebarComponent,
    GenericTableComponent,
    DateSelectComponent,
    FormInputComponent,
    FormSelectComponent,
    PatientSearchDialogComponent,
    BreadcrumbComponent,
    UserProfileMenuComponent,
    ComingSoonComponent,
    PageHeaderComponent,
    AppCheckboxComponent,
    AppToggleComponent,
    AppSelectComponent,
    AppOptionComponent,
    AppTabComponent,
    AppTabGroupComponent,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class SharedModule {}
